import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { isEventContentFeedDetails } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";

export { default } from "./EventView.vue";
export const selector = (feed: ContentFeed): boolean => {
  return isEventContentFeedDetails(feed.details);
};
